import React from "react";
import { connect } from "react-redux";
import moment from "moment";

import TextChart from "../../../Charts/TextChart";
import { formatNumber } from "../../../../shared/formatNumber";
import { storageMonedaSigno } from "../../../../shared/sessionData";

const TextoUltimaCompra = (props) => {
  const { cliente, fecha, idComproba, nombre, referencia, total, loading, } = props;
  const indSinInfo = idComproba === undefined || idComproba === null;
  const validateDate = moment(fecha).format("DD/MM/YYYY");

  return (
    <TextChart
      title={`Última compra`}
      bigAmount={
        indSinInfo || validateDate._isValid
          ? "Sin info"
          : moment(fecha).format("DD/MM/YYYY")
      }
      smallTextTooltip={
        !indSinInfo && (
          <div>
            Nombre: {nombre}
            <br />
            Numero: {referencia}
            <br />
            Importe:
            {` ${storageMonedaSigno()} ${formatNumber(total)}`}
          </div>
        )
      }
      noClient={!cliente}
      smallText={
        !indSinInfo
          ? `Comprobante: ${idComproba} ${referencia}`
          : "Comprobante: -"
      }
      loading={loading}
      imgSinDatos={indSinInfo}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    cliente: state.clientes.clienteById.cliente,
    fecha: state.clientes.ultimaCompra.fecha,
    idComproba: state.clientes.ultimaCompra.idComproba,
    nombre: state.clientes.ultimaCompra.nombre,
    referencia: state.clientes.ultimaCompra.referencia,
    total: state.clientes.ultimaCompra.total,
    loading: state.clientes.ultimaCompra.loading,
  };
};

const mapDispatchToProps = () => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(TextoUltimaCompra);
